import React, { FC, useEffect, useState } from "react";
import { Form, Input, Select, Row, Col, Button } from "antd";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import { DatePicker } from "antd";
import { RootState } from "../../../../../store/store";
import { useSelector } from "react-redux";
import DiagnosisSelectorModal from "../../../../../utils/DiagnosisSelectorModal";

interface EchsEmergencyDiagnosticFormProps {
  form: any;
  loading?: boolean;
  disabled: any;
  removedDiagnoses: any;
  setRemovedDiagnoses: any;
}

const { Option } = Select;

const EchsEmergencyDiagnosticForm: FC<EchsEmergencyDiagnosticFormProps> = ({
  form,
  loading,
  disabled,
  removedDiagnoses,
  setRemovedDiagnoses,
}) => {
  const isRta = Form.useWatch("isRta", form);
  const diagnosisList = Form.useWatch("provisionalDiagnosis", form) || [];

  const { patients } = useSelector((state: RootState) => state);

  const [diagnosisTypes] = useState([
    { label: "Final", value: "Final" },
    { label: "Relevant", value: "Relevant" },
    { label: "Others", value: "Others" },
  ]);

  useEffect(() => {
    if (diagnosisList.length === 0 && !diagnosisList.length) {
      form.setFieldsValue({
        provisionalDiagnosis: [
          {
            // diagnosisId: 1,
            diagnosis: "",
            icdCode: "",
            typeOfDiagnosis: "Final",
          },
        ],
      });
    }
  }, []);

  const [modalVisible, setModalVisible] = useState(false);
  const [activeRowIndex, setActiveRowIndex] = useState<number | null>(null);

  const handleOpenModal = (index: number) => {
    setActiveRowIndex(index);
    setModalVisible(true);
  };

  const handleModalSave = (diagnosis: string, icdCode: string) => {
    const current = form.getFieldValue("provisionalDiagnosis");
    const updated = [...current];
    updated[activeRowIndex!] = {
      ...updated[activeRowIndex!],
      diagnosis,
      icdCode,
    };
    form.setFieldsValue({ provisionalDiagnosis: updated });
  };

  return (
    <div className="echs-emergency-diagnostic">
      <Row gutter={[24, 0]} className="form-row">
        <Col span={12}>
          <Form.Item
            name="isRta"
            label="IS RTA?"
            // rules={[{ required: true, message: "*" }]}
          >
            <Select placeholder="Select Option" disabled={disabled}>
              <Select.Option value="true">YES</Select.Option>
              <Select.Option value="false">NO</Select.Option>
            </Select>
          </Form.Item>
        </Col>

        {isRta === "true" && (
          <>
            <Form.Item label="RTA REASON" name="rtaReason">
              <Input placeholder="Enter RTA Reason" disabled={disabled} />
            </Form.Item>

            <Form.Item
              label="RTA DATE"
              name="rtaDate"
              style={{ marginLeft: "12px" }}
            >
              <DatePicker
                showTime
                format="DD-MM-YYYY HH:mm:ss"
                placeholder="Select RTA Date"
                disabled={disabled}
              />
            </Form.Item>
          </>
        )}
      </Row>

      <Row gutter={[24, 0]} className="form-row">
        <Col span={12}>
          <Form.Item
            name="admissionAilment"
            label="ADMISSION AILMENT"
            rules={[
              { required: true, message: "Please Input Admission Ailment" },
            ]}
          >
            <Input placeholder="Enter Admission Ailment" disabled={disabled} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="ailmentDuration"
            label="Present Symptom Duration"
            // rules={[{ required: true, message: "*" }]}
          >
            <Input
              placeholder="Enter Present Symptom Duration"
              disabled={disabled}
            />
          </Form.Item>
        </Col>
      </Row>

      <div className="provisional-diagnosis-section">
        <h4>PROVISIONAL DIAGNOSIS</h4>
        <Form.List name="provisionalDiagnosis">
          {(fields, { add, remove }) => (
            <>
              <div
                style={{
                  maxHeight: "50vh",
                  overflowY: "auto",
                  overflowX: "hidden",
                  padding: "20px",
                  marginBottom: "1rem",
                }}
              >
                {fields.map(({ key, name, ...restField }, index) => (
                  <Row key={key} gutter={[24, 0]} className="form-row">
                    <Col span={3}>
                      <Form.Item
                        {...restField}
                        name={[name, "typeOfDiagnosis"]}
                        // rules={[{ required: true, message: "*" }]}
                      >
                        <Select
                          placeholder="Select Diagnosis Type"
                          disabled={disabled}
                          allowClear
                        >
                          {diagnosisTypes.map((item) => (
                            <Option key={item.value} value={item.value}>
                              {item.label}
                            </Option>
                          ))}
                        </Select>
                        {/* <Input
                                            placeholder="Enter Diagnosis"
                                            disabled={disabled}
                                          /> */}
                      </Form.Item>
                    </Col>
                    <Col span={13}>
                      <Form.Item
                        {...restField}
                        name={[name, "diagnosis"]}
                        // rules={[{ required: true, message: "*" }]}
                      >
                        <Input
                          placeholder="Enter Diagnosis"
                          // disabled={true}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={3}>
                      <Form.Item
                        {...restField}
                        name={[name, "icdCode"]}
                        // rules={[{ required: true, message: "*" }]}
                      >
                        <Input
                          placeholder="Enter ICD Code"
                          // disabled={true}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={3}>
                      <Button
                        type="primary"
                        onClick={() => handleOpenModal(index)}
                        disabled={disabled}
                        style={{
                          backgroundColor: "rgb(0, 76, 143)",
                          color: "#fff",
                          boxShadow: "0px 2px 8px 0px #00000040",
                        }}
                      >
                        Add Diagnosis
                      </Button>
                    </Col>
                    {disabled ? (
                      <></>
                    ) : (
                      <Col span={2}>
                        <MinusCircleOutlined
                          // onClick={() => remove(name)}
                          onClick={() => {
                            const currentList =
                              form.getFieldValue("provisionalDiagnosis") || [];
                            setRemovedDiagnoses((prev: any) => [
                              ...prev,
                              { ...currentList[name], status: false },
                            ]);
                            remove(name);
                          }}
                        />
                      </Col>
                    )}
                  </Row>
                ))}
              </div>
              {disabled ? (
                <></>
              ) : (
                <Form.Item>
                  <Button
                    type="dashed"
                    // onClick={() => add()}
                    onClick={() =>
                      add({
                        diagnosis: "",
                        icdCode: "",
                        status: true,
                        typeOfDiagnosis: "Final",
                      })
                    }
                    block
                    icon={<PlusOutlined />}
                    disabled={disabled}
                  >
                    Add Provisional Diagnosis
                  </Button>
                </Form.Item>
              )}
            </>
          )}
        </Form.List>
      </div>

      <DiagnosisSelectorModal
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        onSave={handleModalSave}
        hospitalId={patients?.fetchBasicDetails?.casesResponse?.healthCareId}
        schemeId={patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId}
      />
    </div>
  );
};

export default EchsEmergencyDiagnosticForm;
